import React from 'react';
import { Container, Typography, Box, Fade } from '@mui/material';
import { DirectionsCar } from '@mui/icons-material';
import MisVehiculosList from '../../components/MovilidadElectrica/MisVehiculosList';
import { MovilidadElectricaProvider } from '../../context/MovilidadElectricaContext';

const VehiculosPage = () => {
  return (
    <Fade in timeout={800}>
      <Container 
        maxWidth={false} 
        sx={{ 
          py: { xs: 1.5, sm: 2, md: 3 },
          px: { xs: 2, sm: 3, md: 4, lg: 6 },
          maxWidth: '1600px',
          mx: 'auto',
          width: '100%'
        }}
      >
        {/* Header moderno */}
        <Box sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: { xs: 1.5, sm: 2 }, 
          mb: { xs: 2, sm: 2.5, md: 3 }
        }}>
          <Box
            sx={{
              p: { xs: 1, sm: 1.25, md: 1.5 },
              borderRadius: { xs: 2, sm: 2.5, md: 3 },
              background: 'linear-gradient(135deg, #002642 0%, #00577A 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <DirectionsCar sx={{ 
              color: '#FFFFFF', 
              fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2rem' } 
            }} />
          </Box>
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
                color: '#002642',
                fontSize: { xs: '1.25rem', sm: '1.5rem', md: '2rem', lg: '2.25rem' },
                mb: { xs: 0.25, sm: 0.5 },
                lineHeight: { xs: 1.3, sm: 1.2, md: 1.1 }
              }}
            >
              Mis Vehículos
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: '#75787B',
                fontSize: { xs: '0.8rem', sm: '0.9rem', md: '1rem' },
                lineHeight: 1.4
              }}
            >
              Gestiona tus vehículos eléctricos registrados
            </Typography>
          </Box>
        </Box>

        {/* Content */}
        <MovilidadElectricaProvider>
          <MisVehiculosList />
        </MovilidadElectricaProvider>
      </Container>
    </Fade>
  );
};

export default VehiculosPage;
